
export enum NoteSection {
	ChiefComplaint = "Chief Complaint",
	Hpi = "History of Present Illness",
	PhysicalExam = "Physical Exam",
	Assessment = "Assessment",
	Plan = "Plan"
}

/** Recording state of the page */
export enum RecordingStates {
	/** Waiting to determine if mic supported */
	Initial,

	/** No audio devices found */
	NoDevices,

	/** Recording not supported */
	Unsupported,

	/** The user declined mic access */
	MicDeclined,

	/** Waiting for the user to either record or upload a file */
	Waiting,

	/** Unknown error with recording */
	Error,

	/** The user is currently recording audio */
	Recording,

	/** If the recording is paused, this is an optional state */
	Paused,

	/** Done recording waiting to end recording or start another part */
	Done
}
